
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2984367493/src/vl-app/pages/linklogin.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { NextPage } from '../stubs/next-types';
import LoginLayout from '@components/Layouts/Login';
import RestrictedAccessView from '@components/Login/views/RestrictedAccessView';

const LinkLogin: NextPage = () => (
  <LoginLayout>
    <RestrictedAccessView isNHS />
  </LoginLayout>
);

export default LinkLogin;
export const Route = createFileRoute('/linklogin')({ component: LinkLogin });
